import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Button, Icon } from "semantic-ui-react";
import Modal from 'react-bootstrap/Modal';
import Swal from "sweetalert2";

import "../src/css/convenios.css";

let SoliNUM: number;
let CType: string;
let insti: any;

interface IFileData {
  file: any;
  name: string;
  type: string;
  description: string;
}

interface IFormData {
  id: number;
  ContentType: string;
  files: IFileData[];
}

export default observer(function UploadFileModal(MOD: { show: any, onHide: any, solicitudID: any, CType: string, insti:any, }) {
  
  SoliNUM = MOD.solicitudID;
  CType = MOD.CType;
  insti = MOD.insti;

  const apiURL = process.env.REACT_APP_API_URL + `/Storage`;
  const [file, setFile] = useState<File | null>(null);
  const [description, setDescription] = useState("");
  const [formData, setFormData] = useState<IFormData>({ id: +SoliNUM, files: [], ContentType: CType });
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.files) {
  //     setSelectedFiles([...selectedFiles, event.target.files[0]]);
  //     setFile(event.target.files[0]);
  //   }
  // };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFiles([...selectedFiles, event.target.files[0]]);
      setFile(event.target.files[0]);
      setDescription("");
    }
  };

  const handleDescriptionChanges = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setDescription(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (file && description) {
      const fileData: IFileData = {
        file: file,
        name: file.name,
        type: file.type,
        description,
      };
      setFormData({
        ...formData,
        files: [...formData.files, fileData],
      });
      setDescription("");
      setFile(null);
    }
  };

  const handleSend = () => {
    const formDataToSend = new FormData();
    formDataToSend.append("id", SoliNUM.toString());
    formDataToSend.append("ContentType", CType);
    formData.files.forEach((fileData, index) => {
      formDataToSend.append(`Files[${index}].File`, fileData.file);
      formDataToSend.append(
        `Files[${index}].Description`,
        fileData.description
      );
    });
    fetch(apiURL, {
      method: "POST",
      body: formDataToSend,
    }).then(function (r) {
      if (r.status == 200) {
        return insti ? ExitValInsti() : ExitVal();
      } else { ExitMsjError() }
    });
  };
  
  function ExitVal() {
    Swal.fire({
      position: "center",
      showCloseButton: true,
      title: 'Archivos creados exitosamente',
      text: "Tu solicitud fue creada exitosamente, y adjuntaste los primeros archivos, ahora te sugerimos crear el código institucional",
      icon: 'success',

      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonAriaLabel: "confirm-button",

    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
        // window.location.href = `/cargapagos/crear-convenio`;
      } else if (result.isDismissed) {
        window.location.reload()
      }
    })
  };

  function ExitValInsti() {
    Swal.fire({
      position: "center",
      showCloseButton: true,
      title: 'Archivos creados exitosamente',
      text: "Tu solicitud fue creada y adjuntaste los primeros archivos del proceso exitosamente.",
      icon: 'success',

      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonAriaLabel: "confirm-button",

    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      } else if (result.isDismissed) {
        window.location.reload()
      }
    })
  };

  function ExitMsjError() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "Error",
      text: 'Ha ocurrido un error en la actualización, por favor verifica que la informacion sea correcta e intenta de nuevo.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  return (
    <Modal
      {...MOD}
      size="lg"
      className="modal-add-dep-content"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Modal.Header closeButton >
        <Modal.Title id="contained-modal-title-vcenter">
          <h2>Subir nuevo archivo</h2>
        </Modal.Title>
      </Modal.Header>

      <Container className="form-upload-file-area">

        <Modal.Body className="upload-files-modal">
          <div className="form-header">
            <hr />
            <h3 className="info-message-convenio">
              Utiliza el siguiente formulario para subir archivos correspondientes
              al código.
            </h3>
          </div>
          <Row className="form-file-temp-area">
            <label>Archivos seleccionados:</label>

            {selectedFiles?.map((file, index) => (

              <Row className="list-file-temp">
                
                <Col xs={10}>
                  <div className="temp-file" key={index}>
                    {formData.files[index]?.name} - {formData.files[index]?.description} {" "}
                  </div>
                </Col>
                <Col xs={2}>
                  <button className="delete-temp-file" onClick={() => setSelectedFiles(selectedFiles?.filter((f, i) => i !== index))}>
                    Eliminar
                  </button>
                </Col>
              </Row>

            ))}

          </Row>

          <form onSubmit={handleSubmit}>
            <Row className="input-file-select">
              <input
                className="file-upload-custom"
                id="file-upload"
                type="file"
                onChange={handleFileChange}
              />
            </Row>

            <Row className="descripcion-file-form">
              <label htmlFor="description-input">Descripción:</label>
              <textarea
                id="description-input"
                rows={4}
                value={description}
                onChange={handleDescriptionChanges}
              />
            </Row>

            <Row className="buttons-form-upload upload-files">
              <Button className=" button-green" type="submit" animated>
                <Button.Content visible> Cargar archivos </Button.Content>
                <Button.Content hidden>
                  <Icon name="file pdf outline" />
                </Button.Content>
              </Button>
            </Row>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Row className="buttons-form-upload send-file">
            <Button className="primary" animated onClick={handleSend}>
              <Button.Content visible>Subir archivos</Button.Content>
              <Button.Content hidden>
                <Icon name="send" />
              </Button.Content>
            </Button>
          </Row>
        </Modal.Footer>

      </Container>

    </Modal>
  );









})

